import e from "./index836.js";
import i from "./index837.js";
import a from "./index816.js";
function f(r) {
  return a(r) ? e(r) : i(r);
}
export {
  f as default
};
